import { render, staticRenderFns } from "./BlankRPDeviceRegisterJournalPassport.vue?vue&type=template&id=680caa62&scoped=true"
import script from "./BlankRPDeviceRegisterJournalPassport.vue?vue&type=script&lang=js"
export * from "./BlankRPDeviceRegisterJournalPassport.vue?vue&type=script&lang=js"
import style0 from "./BlankRPDeviceRegisterJournalPassport.vue?vue&type=style&index=0&id=680caa62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680caa62",
  null
  
)

export default component.exports